import React from 'react';
import { AlertTriangle, Loader2, X } from 'lucide-react';
import './ScopeChangeDismissConfirmModal.css';

export type ScopeChangeDismissConfirmModalProps = {
  open: boolean;
  supplierName: string;
  busy?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ScopeChangeDismissConfirmModal: React.FC<ScopeChangeDismissConfirmModalProps> = ({
  open,
  supplierName,
  busy = false,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div
      className="ops-modal-overlay scd-modal-overlay"
      role="presentation"
      onClick={() => {
        if (!busy) onClose();
      }}
    >
      <div
        className="ops-modal scd-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="scd-modal-title"
        aria-describedby="scd-modal-desc"
        onClick={e => e.stopPropagation()}
      >
        <header className="ops-modal-header scd-modal-header">
          <AlertTriangle size={18} aria-hidden className="scd-modal-icon" />
          <h3 id="scd-modal-title">Dismiss scope change reminder?</h3>
          <button
            type="button"
            className="ops-modal-close"
            aria-label="Close"
            disabled={busy}
            onClick={onClose}
          >
            <X size={16} aria-hidden />
          </button>
        </header>
        <div className="ops-modal-body scd-modal-body">
          <p id="scd-modal-desc" className="scd-modal-lead">
            <strong>{supplierName}</strong> will not receive a scope-change email. The published
            package will be updated to match their current structure selection, and this reminder
            will be cleared.
          </p>
        </div>
        <footer className="ops-modal-footer scd-modal-footer">
          <button type="button" className="ops-hide-completed-btn" disabled={busy} onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="ops-new-btn scd-modal-confirm"
            disabled={busy}
            onClick={() => void onConfirm()}
          >
            {busy ? (
              <>
                <Loader2 size={14} className="scd-modal-spin" aria-hidden /> Dismissing…
              </>
            ) : (
              'Dismiss reminder'
            )}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ScopeChangeDismissConfirmModal;
